<script setup>
  import { ref } from 'vue';
  import { ElCarousel,ElCarouselItem } from 'element-plus'
  import 'element-plus/dist/index.css'
  const seleFeatIndex = ref(0)
  const activeIndex = ref(0)
  const prevse  = ref('prevse')
  const carouselList = ref([
    [
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg1.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg2.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg3.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg4.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg5.png',

    ],
    [
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg6.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg7.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg8.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg9.png',
        'https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselImg10.png',

    ],
  ])
  const featureList = ref([
    {
        title:'绿色资产',
        mess:'地铁、公交、骑行、新能源车出行获取碳减排量，碳减排量收集后作为个人碳资产，以区块链技术全周期存证'
    },{
        title:'活动任务',
        mess:'日常签到、低碳答题、行走、分享等任务，可获得积分奖励，不定期组织丰富有趣的低碳出行活动'
    },{
        title:'减排提现',
        mess:'低碳行为收益可实时兑换提现，引入数字人民币作为计价和支付手段'
    },{
        title:'权益兑换',
        mess:'低碳商城提供乘车券、ip文创等多种低碳专享权益，使用碳减排量和日常积分均可兑换'
    },{
        title:'低碳社交',
        mess:'低碳社区为用户提供绿色低碳生活交流空间，倡导简约适度、低碳健康的生产生活方式'
    },
  ])
  function mouseoverse(index){
    seleFeatIndex.value = index
  }
  function prevsese(index){
    prevse.value.prev()
    activeIndex.value--
  }
  function nextese(){
    prevse.value.next()
    activeIndex.value++
  }
</script>

<template>
    <!-- 功能介绍 -->
    <div class="featureThomse">
        <!-- 我们更加轻松 -->
         <div class="featureCen1">
            <img class="featureLeftImg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/featureLeftImg.png" alt="">
            <div class="featureLeft">
                <p class="featureTxt">我们更加轻松</p>
                <p class="featureTit">引领公众践行低碳生活</p>
                <div @mouseover="mouseoverse(index)" v-for="(item,index) in featureList" :key="index" :class="index===seleFeatIndex?'seleIndexfeature featureList':'featureList'">
                    <!-- <img :class="index===seleFeatIndex?'seleFeatureIcon featureIcon':'featureIcon'" :src="require(`../assets/featureIcon${index+1}.png`)" alt=""> -->
                    <img :class="index===seleFeatIndex?'seleFeatureIcon featureIcon':'featureIcon'" :src="`https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/featureIcon${index+1}.png`" alt="">
                    <div class="featureMess">
                        <p class="featMess1">{{item.title}}</p>
                        <p class="featMess2">{{item.mess}}</p>
                    </div>
                </div>
            </div>
            <div class="featureRight">
                <img class="featureImg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/featureImg.png" alt="">
            </div>
         </div>
         <!-- 生态合作伙伴 -->
         <div class="ecologyCen">
            <p class="ecologyTxt">了解我们一下</p>
            <p class="ecologyTit">生态合作伙伴</p>
            <div class="ecologyCenter">
                <!-- <img v-for="(item,index) in 15" :key="index" class="ecologyImg" :src="require(`../assets/ecologyImg${index+1}.png`)" alt=""> -->
                <img v-for="(item,index) in 20" :key="index" class="ecologyImg" :src="`https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/ecologyImg${index+1}.png`" alt="">
            </div>
         </div>
         <!-- 安全合规 -->
          <div class="secureCen">
            <img class="secureBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/secureBg.png" alt="">
            <div class="secuCen">
                <p class="secuTit">安全合规、高速稳定的基础设施建设</p>
                <img v-if="activeIndex>0" @click="prevsese(0)" class="arrow2" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/arrow2.png" alt="">
                <img  v-if="activeIndex<1" @click="nextese(0)" class="arrow1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/arrow1.png" alt="">
                <el-carousel initial-index="0" loop="false" :activeIndex="activeIndex" ref="prevse" :autoplay="false" arrow="never" indicator-position="none" :interval="5000">
                    <el-carousel-item v-for="itemse in carouselList" :key="itemse">
                        <div v-for="item in itemse" :key="item" class="carouseList">
                            <img class="carouselBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/carouselBg.png" alt="">
                            <img class="carouselImg"  :src="item" alt="">
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
          </div>
    </div>
</template>

<style lang="less" scoped>
p{
    margin: 0;
}
@keyframes changeColor {
  from {background-color: blue;}
  to {background-color: red;}
}
@keyframes grow {
    from {
        transform: scale(1); /* 初始大小 */
    }
    to {
        transform: scale(1.2); /* 放大到1.5倍 */
    }
}
.featureThomse{
    width: 100%;
    background: #fff;
    .secureCen{
        width: 100%;
        margin-top: 40px;
        position: relative;
        .secuCen{
            width: 80%;
            margin: 0 auto;
            position: absolute;
            top: 20%;
            left: 50%;
            transform: translateX(-50%);
            .arrow2{
                width: 40px;
                position: absolute;
                left: -15px;
                top: 62%;
                z-index: 10;
            }
            .arrow2:hover{
                animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
            }
            .arrow1:hover{
                animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
            }
            .arrow1{
                width: 40px;
                position: absolute;
                right: -15px;
                top: 63%;
                z-index: 10;
            }
            .secuTit{
                font-size: 32px;
                color: #000B33;
                font-weight: 300;
                margin-bottom: 6%;
            }
            .carouseList{
                width: 25%;
                height: 93%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                // background-image: url('../assets/carouselBg.png');
                // background-size: 100% 100%;
                // padding: 30px 15px;
                .carouselImg{
                    width: 73%;
                    position: relative;
                    z-index: 9;
                    // margin-top: -12px;
                }
                .carouselBg{
                    width: 100%;
                    position: absolute;
                    top: 0;
                    z-index: 0;
                    box-shadow: rgba(#9ECFE9,0.15) 10px 10px 10px;
                }
            }

            .el-carousel__item{
                display: flex;
                justify-content: space-evenly;
                align-items: center;
            }
            .el-carousel__item h3 {
                // color: #475669;
                line-height: 300px;
                margin: 0;
                text-align: center;
            }

            .el-carousel__item:nth-child(2n) {
                // background-color: #99a9bf;
            }

            .el-carousel__item:nth-child(2n + 1) {
                // background-color: #d3dce6;
            }
        }
        .secureBg{
            width: 100%;
        }
    }
    .ecologyCen{
        width: 100%;
        background: #fff;
        .ecologyTxt{
            width: 83%;
            margin: 0 auto;
            text-align: left;
            font-size: 16px;
            color: #00BB98;
        }
        .ecologyTit{
            width: 83%;
            margin: 5px auto 0;
            text-align: left;
            font-size: 32px;
            color: #000B33;
            font-weight: 300;
        }
        .ecologyCenter{
            width: 87%;
            margin: 10px auto 0;
            display: flex;
            // justify-content: space-between;
            flex-wrap: wrap;
            .ecologyImg{
                width: 20%;
            }
        }
    }
    .featureCen1{
        width: 100%;
        height: 920px;
        background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/featureBg.png');
        background-size: 100% auto;
        display: flex;
        position: relative;
        .featureLeftImg{
            width: 4%;
            position: absolute;
            left: 0;
            top: 22%;
            z-index: 10;
        }
        .featureLeft{
            // width: 40%;
            height: 100%;
            margin-left: 8%;
            margin-top: 8%;
            display: flex;
            flex-direction: column;
            // align-items: center;
            .featureTxt{
                width: 100%;
                font-size: 18px;
                color: #00BB98;
                font-weight: 300;
                text-align: left;
            }
            .featureTit{
                // width: 65%;
                width: 90%;
                font-size: 31px;
                color: #000B33;
                text-align: left;
                font-weight: 300;
                letter-spacing: 2px;
                margin-top: 16px;
                margin-bottom: 45px;
            }
            .featureList{
                width: 80%;
                display: flex;
                align-items: center;
                margin-top: 10px;
                padding: 15px 5px 20px 10px;
                margin-left: -10px;
                .featureIcon{
                    width: 50px;
                    border: 2px solid rgba(#fff,0);
                    box-shadow: rgba(#9ECFE9,0) 0px 5px 5px 0px;
                }
                .seleFeatureIcon{
                    border: 2px solid #fff;
                    border-radius: 25px;
                    box-shadow: rgba(#9ECFE9,0.4) 0px 5px 5px 0px;
                }
                .featureMess{
                    text-align: left;
                    margin-left: 3%;
                    .featMess1{
                        font-size: 17px;
                        color: #000B33;
                        font-weight: 300;
                    }
                    .featMess2{
                        width: 100%;
                        font-size: 13px;
                        color: rgba(#000B33,0.8);
                        font-weight: 300;
                        letter-spacing: 1px;
                        margin-top: 5px;
                        line-height: 20px;
                    }
                }
            }

            .seleIndexfeature{
                width: 80%;
                background: #fff;
                box-shadow: #00BB98;
                padding: 15px 5px 20px 10px;
                // margin-top: 20px;
                // border: 1px solid #00BB98;
                border-radius: 10px;
                background: linear-gradient(to bottom, #fff, rgba(#EFFFFF));
                box-shadow: rgba(#9ECFE9,0.15) 0px 10px 10px 0px;
            }
        }
        .featureRight{
            width: 60%;
            height: 100%;
            display: flex;
            align-items: center;
            .featureImg{
                width: 80%;
            }
        }
    }
}

</style>